export default __webpack_public_path__ + "static/indy-heart-cf7fedce025354eaa5ed8d129e7f4def.png";